/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/common';
import * as import4 from 'ngx-pagination';
import * as import5 from '../../../$$_gendir/node_modules/ngx-pagination/dist/ngx-pagination.ngfactory';
import * as import6 from '@angular/router';
import * as import7 from '../../../app/news/news-history.component';
import * as import8 from '../../../app/services/news.service';
import * as import9 from '../../../app/services/local-storage.service';
import * as import10 from 'angular2-notifications/src/notifications.service';
const styles_NewsHistoryComponent:any[] = ([] as any[]);
export const RenderType_NewsHistoryComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_NewsHistoryComponent,
  data: {}
}
);
function View_NewsHistoryComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie listy aktualności'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_NewsHistoryComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'empty-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak historycznych aktualności do wyświetlenia'])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_NewsHistoryComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'td',[[
        'style',
        'white-space: pre-line;'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.title;
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit.date_start;
    ck(v,6,0,currVal_1);
    const currVal_2:any = v.context.$implicit.message;
    ck(v,8,0,currVal_2);
  });
}
function View_NewsHistoryComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'table-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',[[
        'style',
        'width:20%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Tytuł'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',[[
        'style',
        'width:20%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['D. aktualności'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Treść'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),3,(null as any),View_NewsHistoryComponent_4)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpod([
      'itemsPerPage',
      'currentPage'
    ]
    ),
    import0.ɵpid(0,import4.PaginatePipe,[import4.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PaginationControlsComponent_0,import5.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import4.PaginationControlsComponent,([] as any[]),{
      directionLinks: [
        0,
        'directionLinks'
      ]
      ,
      previousLabel: [
        1,
        'previousLabel'
      ]
      ,
      nextLabel: [
        2,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,22,0,import0.ɵnov(v,24).transform(co.newsHistory,ck(v,23,0,5,co.p)));
    ck(v,22,0,currVal_0);
    const currVal_1:any = 'true';
    const currVal_2:any = 'Poprzednie';
    const currVal_3:any = 'Następne';
    ck(v,29,0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
export function View_NewsHistoryComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),39,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),36,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewsHistoryComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'filters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'header',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Lista aktualności:'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'class',
        'heading-h3'
      ]
      ,
      [
        'routerLink',
        '/news/list'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,21).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import6.RouterLinkWithHref,[
      import6.Router,
      import6.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Aktualne'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'inactive heading-h3'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Historia'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'bar columns tall'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewsHistoryComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewsHistoryComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.NewsHistoryComponent = v.component;
    const currVal_0:any = co.newsHistoryListLoading;
    ck(v,5,0,currVal_0);
    const currVal_3:any = '/news/list';
    ck(v,21,0,currVal_3);
    const currVal_4:boolean = (!co.newsHistoryListLoading && !co.newsHistory.length);
    ck(v,34,0,currVal_4);
    const currVal_5:any = (co.newsHistory.length && !co.newsHistoryListLoading);
    ck(v,37,0,currVal_5);
  },(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,21).target;
    const currVal_2:any = import0.ɵnov(v,21).href;
    ck(v,20,0,currVal_1,currVal_2);
  });
}
function View_NewsHistoryComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_NewsHistoryComponent_0,RenderType_NewsHistoryComponent)),
    import0.ɵdid(114688,(null as any),0,import7.NewsHistoryComponent,[
      import8.NewsService,
      import9.LocalStorageService,
      import10.NotificationsService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NewsHistoryComponentNgFactory:import0.ComponentFactory<import7.NewsHistoryComponent> = import0.ɵccf('app-main',import7.NewsHistoryComponent,View_NewsHistoryComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/news/news-history.component.ngfactory.ts